"use client";

import dynamic from "next/dynamic";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import Sites from "../../constants/Sites";
import { useAppContext } from "@components/Provider";
import { isIPadProOnSafari } from "../../helpers/Helper";
import Sticky from "app/StickyNode";

import "./GlobalLayout2.css";

//Dynamic import based on https://github.com/zeit/next.js/blob/canary/examples/with-dynamic-import/pages/index.js
// {/ Load immediately, but in a separate bundle / }
const Header = dynamic(() => import("../Header/Header"));
const Footer = dynamic(() => import("../Footer"));
const GoogleAdSenseDisplay = dynamic(() => import("../Ads/GoogleAdSenseDispalyAd"), { ssr: false });
const GoogleAdSense = dynamic(() => import("../Ads/GoogleAdSense"), { ssr: false });
const SheKnowsAd = dynamic(() => import("../Ads/SheKnowsAd"), { ssr: false });
const NewHeader = dynamic(() => import("../Header/NewHeader"), { ssr: false });

const renderRightRailAds = ({
  className,
  stickyTop,
  bottomBoundary,
  adnetwork,
  isMobile,
  isTablet,
  isIpadpro,
}) => {
  if (!isMobile && !isTablet && !isIpadpro) {
    return (
      <div className={className || ""}>
        <Sticky bottomBoundary={bottomBoundary} top={stickyTop}>
          {!isMobile && adnetwork && adnetwork === "SheKnows" ? (
            <>
              <SheKnowsAd type={"medrec"} />
              <br />
              <SheKnowsAd type={"flexrec"} />
            </>
          ) : (
            <ErrorBoundary
              fallback={<div className="right_rail_add_bookdetailLayout"></div>}
            >
              <GoogleAdSense /> <br />
              <GoogleAdSense />
            </ErrorBoundary>
          )}
        </Sticky>
        <style>
          {`
            .right_rail_add_bookdetailLayout {
              flex: 0 0 310px;
              background-color: #f5f7fa;
              margin-left: 1rem;
              max-width: 310px;
              min-height: 600px;
            }
            @media (max-width: 991px) {
              .right_rail_add_bookdetailLayout {
                display: none;
              }
            }
          `}
        </style>
      </div>
    );
  }
};

const renderDisplayAd = (
  className,
  adnetwork,
  isMobile,
  displayResponsiveAd
) => {
  if (!isMobile) {
    return (
      <React.Fragment>
        <div className={className}>
          {adnetwork === "SheKnows" ? (
            <SheKnowsAd id={`skm-ad-banner-${className}`} />
          ) : displayResponsiveAd ? (
            <GoogleAdSense />
          ) : (
            <GoogleAdSenseDisplay />
          )}
        </div>
        <style>
          {`
            .topad_bookdetailLayout {
              padding-top: 75px;
              text-align: center;
              padding-bottom: 2px;
              border-bottom: 1px solid black;
              min-height: 175px;
            }
            .paddingTop_bookdetailLayout {
              padding-top: 75px;
            }
            .bottomad_bookdetailLayout {
              text-align: center;
              padding-bottom: 5px;
              padding-top: 7px;
              border-top: 1px solid black;
            }
            @media only screen and (min-width: 320px) and (max-width: 767px) {
              .paddingTop_bookdetailLayout {
                padding-top: 125px;
              }
            }
          `}
        </style>
      </React.Fragment>
    );
  }
};

const renderEmptyDiv = (siteId, path) => {
  /* {/ Empty div to release sticky right rail ads, don't delete /} */
  if (siteId === Sites.EARLYBIRDBOOKS && path === "/") {
    return <div></div>;
  } else {
    return (
      <div className="empty">
        <br />
      </div>
    );
  }
};
const BookDetailPageLayout = (props) => {
  const { data, siteId, router, isMobile, isTablet, subscriberCookie, userAgent } = useAppContext();

  let adnetwork = data.SiteSettings.ad_settings.adnetwork,
    topAdPadding = props.isHeader == true ? "paddingTop_bookdetailLayout" : "";
  const isHeader = siteId == Sites.EARLYBIRDBOOKS ? false : true;

  const isIpadpro = isIPadProOnSafari(userAgent);

  return (
    <React.Fragment>
      {isHeader ? <Header isNonClosableModalChecked={false} /> : <NewHeader />}
      <div
        className={`layout_container ${siteId != Sites.OPENROADMEDIA ? "containerWithMargin_bookdetailLayout" : ""}`}
        style={{
          "--top-padding-1024": !subscriberCookie ? "58px" : "15px",
          "--top-padding-712": !subscriberCookie ? siteId == Sites.EARLYBIRDBOOKS ? "0" : "15px" : "15px",
        }}
      >
        {/* {/ Don't display header ad for mobile  /} */}
        <div>
          {renderDisplayAd(
            `topad_bookdetailLayout container_bookdetailLayout ${topAdPadding}`,
            adnetwork,
            isMobile
          )}
        </div>
        <div className="container_bookdetailLayout noTopAd_bookdetailLayout">
          {props.children}
          {renderRightRailAds({
            className: "right_rail_add_bookdetailLayout",
            stickyTop: 120,
            bottomBoundary: ".empty",
            adnetwork: adnetwork,
            isMobile,
            isTablet,
            isIpadpro,
          })}
        </div>
        {renderEmptyDiv(siteId, router.asPath)}

        {renderDisplayAd(
          "bottomad_bookdetailLayout container_bookdetailLayout",
          adnetwork,
          false,
          true
        )}
      </div>
      <Footer />
      <style>
        {`
          .layout_container {
            overflow-x: hidden;
            width: 100%;
            max-width: 100vw;
          }
          .container_bookdetailLayout {
            display: flex;
            margin: ${props.fullWidth ? "0" : "1rem"};
            justify-content: center;
            max-width: 100%;
            overflow-x: hidden;
          }
          .noContainerMargin {
            display: flex;
            justify-content: center;
            max-width: 100%;
            overflow-x: hidden;
          }
          .containerWithMargin_bookdetailLayout {504.,.
            margin: 0 5rem;
            max-width: 100%;
            overflow-x: hidden;
          }
          .containerWithMargin_bookdetailLayout .container_bookdetailLayout {
            margin: 1rem 0;
            max-width: 100%;
            overflow-x: hidden;
          }
          @media only screen and (min-width: 320px) and (max-width: 767px) {
            .container_bookdetailLayout {
              flex-direction: column;
              margin: 0;
              padding: 0 1rem;
              max-width: 100%;
              overflow-x: hidden;
              width: 100%;
            }
            .noTopAd_bookdetailLayout {
              padding-top: 40px;
            }
            .containerWithMargin_bookdetailLayout {
              margin: 0;
              padding: 0 1rem;
              width: 100%;
              max-width: 100%;
            }
            .layout_container {
              padding: 0;
              margin: 0;
              width: 100%;
              max-width: 100%;
            }
          }

          @media (min-width: 768px) {
            .noTopAd_bookdetailLayout {
              padding-top: 0;
            }
          }
          @media (max-width: 991px) {
            .containerWithMargin_bookdetailLayout {
              margin: 0 1rem;
              max-width: 100%;
              overflow-x: hidden;
            }
          }
          @media (max-width: 767px) {
            .containerWithMargin_bookdetailLayout {
              margin: 0;
              padding: 0 1rem;
              max-width: 100%;
              overflow-x: hidden;
            }
          }
          
          @media (max-width: 480px) {
            .layout_container {
              padding: 0;
              margin: 0;
              width: 100%;
              max-width: 100%;
            }
            .container_bookdetailLayout {
              padding: 0 0.5rem;
              margin: 0;
              width: 100%;
              max-width: 100%;
            }
            .containerWithMargin_bookdetailLayout {
              padding: 0 0.5rem;
              margin: 0;
              width: 100%;
              max-width: 100%;
            }
          }
          @media only screen and (min-width: 812px) and (orientation: landscape) and (max-width: 1023px),
            (min-device-width: 414px) and (max-device-height: 896px) and (-webkit-device-pixel-ratio: 3),
            (max-device-width: 767px) and (-webkit-device-pixel-ratio: 2) {
            .container_bookdetailLayout {
              flex-direction: column;
              padding-top: ${!subscriberCookie
            ? siteId == Sites.OPENROADMEDIA
              ? "30px"
              : "52px"
            : "15px"
          };
              max-width: 100%;
              overflow-x: hidden;
            }
          }

          @media (min-width: 712px) and (max-width: 712px) {
            .noTopAd_bookdetailLayout {
              padding-top: ${siteId == Sites.EARLYBIRDBOOKS ? "0px" : "15px"};
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default BookDetailPageLayout;
